import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "button"]
  static classes = ["active", "rotate"]
  static values = {
    isOpen: { type: Boolean, default: false }
  }

  toggle(event) {
    if (event) event.preventDefault()
    this.isOpenValue = !this.isOpenValue
  }

  isOpenValueChanged() {
    this.updateState()
  }

  updateState() {
    // 1. Toggle Content Visibility
    this.contentTargets.forEach(target => {
      target.classList.toggle("hidden", !this.isOpenValue)
    })

    // 2. Toggle Active Class on Button (e.g. for borders)
    if (this.hasButtonTarget && this.hasActiveClass) {
      this.buttonTarget.classList.toggle(this.activeClass, this.isOpenValue)
    }

    // 3. Toggle Rotate Class on Icon
    if (this.hasIconTarget && this.hasRotateClass) {
      this.iconTarget.classList.toggle(this.rotateClass, this.isOpenValue)
    }
  }
}
